import { ComponentProps, forwardRef } from 'react'

import { Autocomplete, styled } from '@mui/material'

import { TextField } from '../TextField/TextField'

export type MultiselectDropdownProps = Omit<ComponentProps<typeof Autocomplete>, 'variant' | 'round' | 'multiple' | 'renderInput'> & {
  round?: boolean
  label?: string
  placeholder?: string
  error?: boolean
  helperText?: string
}

export const MultiselectDropdown = forwardRef<HTMLInputElement, MultiselectDropdownProps>(({ round, label, placeholder, error, helperText, ...props }, ref) => (
  <StyledMultiselectDropdown
    multiple
    $round={round}
    disablePortal
    renderInput={(params) => (
      <TextField
        inputRef={ref}
        label={label}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        {...params}
      />
    )}
    {...props}
  />
))


const StyledMultiselectDropdown = styled(Autocomplete, {
  shouldForwardProp: (prop) => prop !== '$round',
}) <{ $round: boolean | undefined }>`
  width: 100%;

  .MuiAutocomplete-tag {
    margin: 2px 3px;
  }

  .MuiOutlinedInput-root {
    padding: 0px;

    & .MuiAutocomplete-tag {
      height: ${({ theme }) => theme.typography.pxToRem(28)};
    }
  }
`
